import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Campo } from '../../../models/coleta';

@Component({
  selector: 'app-input-otp',
  templateUrl: './input-otp.component.html',
  styleUrls: ['./input-otp.component.scss']
})
export class InputOtpComponent implements OnInit {
  @Input() campo: Campo = {};
  @Input() currentFormControl!: FormControl;
  @Input() readOnly = false;
  @Input() requestFocus = false;

  otpDigits = Array(6).fill(0);
  digitControls: FormControl[] = [];

  ngOnInit(): void {
    // Inicializa os form controls para cada dígito com validações individuais (igual ao original)
    this.digitControls = this.otpDigits.map(() => 
      new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)])
    );

    // Sincroniza os dígitos individuais com o controle principal
    this.digitControls.forEach((control, index) => {
      control.valueChanges.subscribe(() => {
        this.updateMainControl();
      });
    });

    // Se o controle principal já tem valor, preenche os dígitos
    if (this.currentFormControl.value) {
      const value = String(this.currentFormControl.value);
      value.split('').forEach((digit, index) => {
        if (index < 6) {
          this.digitControls[index].setValue(digit, { emitEvent: false });
        }
      });
    }

    // Auto-focus no primeiro input se requestFocus = true
    if (this.requestFocus) {
      setTimeout(() => {
        const firstInput = document.querySelector('.otp-input') as HTMLInputElement;
        if (firstInput) {
          firstInput.focus();
        }
      }, 100);
    }
  }

  getFormControl(index: number): FormControl {
    return this.digitControls[index];
  }

  isValid(): boolean {
    return this.digitControls.every(control => control.valid) && this.getOtpValue().length === 6;
  }

  getOtpValue(): string {
    return this.digitControls.map(control => control.value || '').join('');
  }

  updateMainControl(): void {
    const otpValue = this.getOtpValue();
    this.currentFormControl.setValue(otpValue, { emitEvent: false });
    
    // Marca como touched apenas se algum dígito foi tocado
    if (this.digitControls.some(control => control.touched)) {
      this.currentFormControl.markAsTouched();
    }
  }

  onOtpInput(event: any, index: number): void {
    const value = event.target.value;
    
    if (!/^[0-9]*$/.test(value)) {
      event.target.value = '';
      this.getFormControl(index).setValue('');
      return;
    }

    if (value && index < 5) {
      const nextInput = event.target.parentElement.children[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number): void {
    const target = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !target.value && index > 0) {
      const prevInput = target.parentElement?.children[index - 1] as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
        prevInput.value = '';
        this.getFormControl(index - 1).setValue('');
      }
    }
  }

  onOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text').slice(0, 6);
    
    if (pastedData && /^[0-9]*$/.test(pastedData)) {
      pastedData.split('').forEach((digit, index) => {
        if (index < 6) {
          this.getFormControl(index).setValue(digit);
        }
      });
      
      const lastFilledIndex = Math.min(pastedData.length - 1, 5);
      const nextInput = event.target as HTMLElement;
      const parent = nextInput.parentElement;
      if (parent && lastFilledIndex < 5) {
        const nextField = parent.children[lastFilledIndex + 1] as HTMLInputElement;
        if (nextField) {
          nextField.focus();
        }
      }
    }
  }

}

